/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для списка информеров.
   */
  app.InformerView = app.View.extend({

    events: {
      'click .js-popup-close': 'closeInformer'
    },
    additionalOptions: ['informerUser', 'number'],
    /* Ширина попапа */
    popupWidth: 335,
    /* Ширина и высота кнопки кабинета */
    openerSize: 50,
    /* Примерное значение отступа сверху до кнопки кабинета */
    defaultTop: 75,
    /* Примерное значение отступа справа до попапа */
    defaultRight: 500,
    /* Значение отступа между информерами */
    spaceBetweenPopups: 35,
    /**
     * @inheritDoc
     */
    run: function () {
      var that = this;
      this.openerPopup = $('.b-circle_usr');
      this.template = app.helpers.TemplateHelper.getTemplate('#informer-popup');
      this.$el.html(this.template({model: this.model.toJSON()}));
      this.popup_pos = new als.Popup(this.$el, null, this.$el.find('.js-popup-close'));
      this.$el.appendTo('.popups');
      this.popup_pos.addEventListener(
        als.Popup.EventType.BEFORE_OPEN,
        function () {
          var position = $('body').position(),
            leftOffset = 0,
            topOffset = 0;
          //учитываем смещения на мобильных устройствах
          if (!app.isDesktop) {
            leftOffset = position ? position.left : 0;
            topOffset = position ? position.top : 0;
          }
          var openerOffset = that.openerPopup.offset(),
            openerLeftOffset = openerOffset ? openerOffset.left : 0,
            openerTopOffset = openerOffset ? openerOffset.top : that.defaultTop;
          that.$el.css({
            left: openerLeftOffset
              ? openerLeftOffset - that.popupWidth + that.openerSize - leftOffset
              : 'auto',
            top: openerTopOffset
              + (that.openerPopup.innerHeight() || that.openerSize)
              + 17
              + that.number * that.spaceBetweenPopups
              - topOffset,
            position: 'absolute',
          });
          if (!openerLeftOffset) {
            that.$el.css({
              right: that.defaultRight,
            });
          }
        }
      );
      this.popup_pos.open();
    },

    /**
     * Закрываем информер.
     */
    closeInformer: function () {
      this.informerUser.save({
        'is_disabled': true
      });
    }
  });
})(jQuery);

}.call(window));